import script from "./CollageTileDefaultLayoutMediaWithLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./CollageTileDefaultLayoutMediaWithLink.vue?vue&type=script&lang=ts&setup=true"

import "./CollageTileDefaultLayoutMediaWithLink.vue?vue&type=style&index=0&id=36490700&lang=less"

const __exports__ = script;

export default __exports__